<template>
    <div
        style="z-index:222;background:white;"
        class="v-dialog v-dialog--active v-dialog--persistent v-dialog--fullscreen"
    >
        <RequestViewerForPrint :print="true" v-bind:request-id="request_id"></RequestViewerForPrint>
    </div>
</template>
<script>
import RequestViewerForPrint from './RequestViewerForPrint';
export default {
    props: ['request_id'],
    components: { RequestViewerForPrint },
    mounted() {}
};
</script>